import React from 'react';
import { Icon } from './Icon';

export const EmptyCard = ({ emptyIcon: EmptyIcon, icon, text, textClassName, children }) => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="text-muted text-center my-5">
                    {!!EmptyIcon && <EmptyIcon />}
                    {!!icon && <Icon color="black-30" type="l" size="5x" icon={icon} />}
                    <p className={textClassName ?? 'text-muted mt-3'}>{text}</p>
                    {children}
                </div>
            </div>
        </div>
    );
};
